import { get } from "./request";

const STORAGE_KEY = "mg:currentUserId";

let cachedUserId = null;
let cachedUser = null;
let inflight = null;

const unwrapUser = res => {
  const raw = res?.data ?? res;
  if (
    raw &&
    typeof raw === "object" &&
    raw.data != null &&
    typeof raw.data === "object"
  ) {
    return raw.data;
  }
  return raw;
};

const readStoredUserId = () => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value != null && value !== "" ? value : null;
  } catch {
    return null;
  }
};

const writeStoredUserId = id => {
  try {
    if (id == null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, String(id));
    }
  } catch {
    // ignore
  }
};

/** 同步读取已缓存的当前用户 ID（内存或 localStorage） */
export function getCachedCurrentUserId() {
  if (cachedUserId != null) return cachedUserId;
  const stored = readStoredUserId();
  if (stored != null) cachedUserId = stored;
  return stored;
}

export function cacheCurrentUser(user) {
  if (!user || typeof user !== "object") return;
  const id = user.id ?? user.userId;
  if (id != null) {
    cachedUserId = id;
    writeStoredUserId(id);
  }
  cachedUser = user;
}

export function getCachedCurrentUser() {
  return cachedUser;
}

export function clearCurrentUserCache() {
  cachedUserId = null;
  cachedUser = null;
  inflight = null;
  writeStoredUserId(null);
}

/** 请求并写入缓存；并发调用会合并为同一次请求 */
export async function fetchAndCacheCurrentUser() {
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const res = await get("/user/getCurrentUserInfo");
      const user = unwrapUser(res);
      cacheCurrentUser(user);
      return user;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}

/** 优先读缓存，缺失时再请求一次 */
export async function ensureCurrentUserId() {
  const cached = getCachedCurrentUserId();
  if (cached != null) return cached;

  const user = await fetchAndCacheCurrentUser();
  const id = user?.id ?? user?.userId;
  return id ?? null;
}
